import React from 'react';
import { map, isNil, some, noop } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';
import { button as Button } from 'modules/button';
import { SingleSelect } from 'modules/singleSelect';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { WIDGET_ERROR_TYPE } from 'constants/common';

/*******************************/

// success view
export const drugPricingDrugDetailSuccess = ( props ) => {

    // empty view
    if( props.isDataEmpty ) {
        return (
            <div className='ui-drug-pricing-drug-detail'>
                <div className='ui-drug-pricing-drug-detail__empty-view'>
                    <WidgetError
                        type={ WIDGET_ERROR_TYPE.NO_DATA_FOUND }
                    />
                </div>
            </div>
        );
    }

    // data view
    return (
        <div className='ui-drug-pricing-drug-detail'>
            {/* title */}
            <div className='ui-drug-pricing-drug-detail__title'>
                { getLabel( props.widgetTitle ) } { props.drugName }
            </div>

            {/* description */}
            <div className='ui-drug-pricing-drug-detail__description'>
                { props.drugDescription }
            </div>

            {/* filters */}
            <div className='ui-drug-pricing-drug-detail__filters-section'>
                <div className='ui-drug-pricing-drug-detail__filters-section__filters'>
                    {
                        map( props.filters, filter => {
                            return (
                                <div key={ filter.name } className='ui-drug-pricing-drug-detail__filters-section__filters__item'>
                                    <div className='ui-drug-pricing-drug-detail__filters-section__filters__item__title'>{ getLabel( filter.title ) }</div>
                                    <div className='ui-drug-pricing-drug-detail__filters-section__filters__item__control'>
                                        <SingleSelect
                                            options={ filter.options }
                                            value={ filter.value }
                                            disabled={ filter.disabled }
                                            onChange={ ( { value } ) => props.onFilterChange( filter.name, value ) }
                                        />
                                    </div>
                                </div>
                            );
                        } )
                    }
                </div>
                <div className='ui-drug-pricing-drug-detail__filters-section__apply-action'>
                    <Button
                        title={ props.applyFilterAction.title }
                        size='large'
                        className='ui-drug-pricing-drug-detail__filters-section__apply-action__button'
                        disabled={ some( props.filters, _filter => isNil( _filter.value ) ) }
                        onClick={ () => props.onViewPrice() }
                    />
                </div>
            </div>
        </div>
    );
};

// set display name
drugPricingDrugDetailSuccess.displayName = 'drugPricingDrugDetailSuccess';

// set default props
drugPricingDrugDetailSuccess.defaultProps = {
    filters: [],
    onViewPrice: noop,
};

// prop types
drugPricingDrugDetailSuccess.propTypes = {};

/*******************************/

// preloader view
export const drugPricingDrugDetailPreloader = () => {
    return (
        <div className='ui-drug-pricing-drug-detail-preloader'>
            <div className='ui-drug-pricing-drug-detail-preloader__title' />
            <div className='ui-drug-pricing-drug-detail-preloader__descriptions'>
                {
                    map( [ 1, 2, 3 ], ( item ) => (
                        <div key={ item } className='ui-drug-pricing-drug-detail-preloader__descriptions__item' />
                    ) )
                }
            </div>
            <div className='ui-drug-pricing-drug-detail-preloader__filters'>
                {
                    map( [ 1, 2, 3, 4 ], ( item ) => (
                        <div key={ item } className='ui-drug-pricing-drug-detail-preloader__filters__item'>
                            <div className='ui-drug-pricing-drug-detail-preloader__filters__item__title' />
                            <div className='ui-drug-pricing-drug-detail-preloader__filters__item__control' />
                        </div>
                    ) )
                }
            </div>
        </div>
    );
};

// set display name
drugPricingDrugDetailPreloader.displayName = 'drugPricingDrugDetailPreloader';

// set default props
drugPricingDrugDetailPreloader.defaultProps = {};

// prop types
drugPricingDrugDetailPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { drugPricingDrugDetail as DrugPricingDrugDetail } from 'ui/views/widgets/drugPricingDrugDetail';
 *
 * // render
 * <DrugPricingDrugDetail propName='propValue'/>
 */
export const drugPricingDrugDetail = withNetworkState( drugPricingDrugDetailPreloader, drugPricingDrugDetailSuccess );
